module.exports = __webpack_public_path__ + "img/t1-blue.c0c66069.png";